import * as apiErrorHelper from 'epic/apiErrorEpicHelper';
import { FunkyAction } from 'shared/middlewares/epic/epicMiddleware.factory';
import { ordersBasketFormQuoteRejected, ordersBasketFormTradeAuthRejected } from 'state/orders-basket/actions';
import { OrdersBasketQuoteResponse, OrdersBasketTradeResponse } from 'state/orders-basket/models';
import {
  ordersBasketFormQuotedThunk,
  ordersBasketFormTradeAuthGrantedThunk,
  ordersBasketFormTradedThunk,
  ordersBasketFormTradeFailedThunk,
  ordersBasketFormTradeRejectedThunk,
} from 'state/orders-basket/thunks';
import { NextTradeAuthorizationResult } from 'state/quotes/trades/trades.model';

export function handleQuoteResponse(quoteResponse: OrdersBasketQuoteResponse, shouldRequestTrade = true): FunkyAction {
  return quoteResponse?.status === 'Quoted'
    ? ordersBasketFormQuotedThunk(quoteResponse.negotiationId, quoteResponse, shouldRequestTrade)
    : ordersBasketFormQuoteRejected(quoteResponse.negotiationId, quoteResponse);
}

export function handleExecuteResponse(
  formId: string,
  tradeResponse: OrdersBasketTradeResponse,
  isBooking = false,
): FunkyAction {
  switch (tradeResponse.status) {
    case 'FULLY_EXECUTED':
      return ordersBasketFormTradedThunk(formId, tradeResponse, isBooking);
    case 'FAILED':
    case 'EXPIRED':
    case 'REJECTED':
    case 'CANCELLED':
      return ordersBasketFormTradeRejectedThunk(formId, tradeResponse);
    default: {
      const error = new Error('Unknown issue. Please contact technical support.');
      return ordersBasketFormTradeFailedThunk(
        formId,
        new apiErrorHelper.EpicApiError(apiErrorHelper.defaultTechnicalErrorKey, error),
      );
    }
  }
}

export function handleTradeAuthResult(
  formId: string,
  tradeAuthResult: NextTradeAuthorizationResult,
  shouldRequestTrade = true,
): FunkyAction {
  return tradeAuthResult?.status === 'Granted'
    ? ordersBasketFormTradeAuthGrantedThunk(formId, tradeAuthResult, shouldRequestTrade)
    : ordersBasketFormTradeAuthRejected(formId, tradeAuthResult);
}
